import React from 'react';
import { Card } from '@/components/ui/card';

export default function AmountCard({ booking }) {
  return (
    <Card className="p-6 glass-card border-accent">
      {booking.gross_total && booking.gross_total > 0 ? (
        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <p className="text-sm font-medium text-muted-foreground">Gross Amount</p>
            <p className="text-xl font-bold">${booking.gross_total.toFixed(2)}</p>
          </div>

          {/* Show discount if there's a difference between gross and final total */}
          {booking.gross_total > booking.final_total && (
            <>
              <div className="flex justify-between items-center text-red-600">
                <div>
                  <p className="text-sm font-medium">
                    Discount
                    {booking.discount_type && booking.discount_value && (
                      <span className="ml-1">
                        ({booking.discount_type === 'percentage' ? `${booking.discount_value}%` : `$${booking.discount_value}`})
                      </span>
                    )}
                  </p>
                  {booking.discount_reason && (
                    <p className="text-xs text-muted-foreground mt-0.5">
                      {booking.discount_reason}
                    </p>
                  )}
                </div>
                <p className="text-xl font-bold">-${(booking.gross_total - booking.final_total).toFixed(2)}</p>
              </div>
              <div className="border-t pt-3"></div>
            </>
          )}

          <div className="flex justify-between items-center">
            <p className="text-lg font-bold uppercase">Net Amount</p>
            <p className="text-4xl font-black font-heading text-primary">${(booking.final_total ?? 0).toFixed(2)}</p>
          </div>
        </div>
      ) : (
        <div className="flex justify-between items-center">
          <p className="text-lg font-bold uppercase">Total Amount</p>
          <p className="text-4xl font-black font-heading">${(booking.final_total ?? 0).toFixed(2)}</p>
        </div>
      )}
    </Card>
  );
}
